import { render, staticRenderFns } from "./mineDetail.vue?vue&type=template&id=64a2259e&scoped=true"
import script from "./mineDetail.vue?vue&type=script&lang=js"
export * from "./mineDetail.vue?vue&type=script&lang=js"
import style0 from "./mineDetail.vue?vue&type=style&index=0&id=64a2259e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a2259e",
  null
  
)

export default component.exports